"use strict";
/**
 * @module "ethpm"
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthPM = void 0;
require('source-map-support/register');
const { EthPM } = require('./ethpm');
exports.EthPM = EthPM;
